var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ik-data-table',{ref:"thresholdColor",attrs:{"entity-name":_vm.$t('threshold_color'),"icon":'mdi-heart',"model":_vm.model},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('v-btn',{staticClass:"red ml-2",on:{"click":_vm.reset}},[_vm._v(" "+_vm._s(_vm.$t('reset_product_threshold'))+" ")])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }